/* eslint-disable @next/next/no-img-element */
import { useRouter } from "next/router";
import { useEffect } from "react";
import classNames from "@lib/classNames";

export interface ImageBlockProps {
  url: string;
  caption?: string;
  path?: string;
}

export const ImageBlock: React.FC<ImageBlockProps> = ({
  url,
  caption,
  path,
}) => {
  const router = useRouter();
  const isCloudjoiStack = router.asPath.includes("cloudjoi");

  useEffect(() => {
    if (isCloudjoiStack) {
      document.querySelectorAll(".cloudjoi-image-block a").forEach((el) => {
        const element = el as HTMLAnchorElement;
        if (!element.href) return;
        const url = new URL(element.href);
        url.searchParams.set("referral", "lumi-news-web");

        element.href = url.toString();
      });
    }
  }, []);

  return (
    <div className={classNames(isCloudjoiStack && "cloudjoi-image-block")}>
      <a href={path || null} target={path ? "_blank" : ""} rel="noreferrer">
        <img src={url} alt={caption || "image"} className="rounded-lg" />
      </a>
      {caption && (
        <p className="pt-2 font-poppins text-text-darkest">{caption}</p>
      )}
    </div>
  );
};

export default {
  name: "image",
  defaultProps: {
    content: "",
  },
  component: ImageBlock,
};
